import React, { useState } from 'react';
import { useNetwork } from '../contexts/NetworkContext';
import { NETWORKS } from '../config/networks';
import './NetworkSelector.css';

const NetworkSelector: React.FC = () => {
  const { currentNetwork, supportedNetworks, switchNetwork, isLoading, error } = useNetwork();
  const [isOpen, setIsOpen] = useState(false);

  const handleNetworkChange = async (networkKey: string) => {
    try {
      await switchNetwork(networkKey);
      setIsOpen(false);
    } catch (err) {
      console.error('Failed to switch network:', err);
    }
  };

  if (supportedNetworks.length === 0) {
    return null;
  }

  return (
    <div className="network-selector">
      <button
        className="network-button"
        onClick={() => setIsOpen(!isOpen)}
        disabled={isLoading}
      >
        <div className="network-info">
          <div className="network-name">
            {currentNetwork?.name || 'Select Network'}
          </div>
          <div className="network-chain-id">
            Chain ID: {currentNetwork?.chainId || 'N/A'}
          </div>
        </div>
        <div className={`network-arrow ${isOpen ? 'open' : ''}`}>
          ▼
        </div>
      </button>

      {isOpen && (
        <div className="network-dropdown">
          {supportedNetworks.map((network) => (
            <button
              key={network.chainId}
              className={`network-option ${
                currentNetwork?.chainId === network.chainId ? 'active' : ''
              }`}
              onClick={() => handleNetworkChange(
                Object.keys(NETWORKS).find(key => NETWORKS[key].chainId === network.chainId) || ''
              )}
            >
              <div className="network-option-info">
                <div className="network-option-name">{network.name}</div>
                <div className="network-option-details">
                  {network.nativeCurrency.symbol} • Chain ID: {network.chainId}
                </div>
              </div>
              {currentNetwork?.chainId === network.chainId && (
                <div className="network-check">✓</div>
              )}
            </button>
          ))}
        </div>
      )}

      {error && (
        <div className="network-error">
          {error}
        </div>
      )}
    </div>
  );
};

export default NetworkSelector;
